import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AgeGate from './components/AgeGate';
import Home from './pages/Home';
import Vinhos from './pages/Vinhos';
import Loja from './pages/Loja';
import Vinhas from './pages/Vinhas';
import Sobre from './pages/Sobre';
import Contacto from './pages/Contacto';
import Carrinho from './pages/Carrinho';
import Checkout from './pages/Checkout';
import CheckoutResult from './pages/CheckoutResult';
import Territorio from './pages/Territorio';
import fotoOrigemHero from './assets/DSC01781.jpg';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosCondicoes from './pages/TermosCondicoes';
import PoliticaCookies from './pages/PoliticaCookies';

/* ── Smooth scroll global (Lenis) ─────────────────────────── */
function useLenis() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,                                  // suavidade
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
      smoothWheel: true,
      smoothTouch: false,                             // touch mantém o nativo
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  // Garantir que ao mudar de rota o scroll volta ao topo (Lenis intercepta o scroll nativo)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
}

function App() {
  useLenis();
  return (
    <>
      <AgeGate />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"          element={<Home />}     />
          <Route path="/vinhos"    element={<Vinhos />}   />
          <Route path="/loja"      element={<Loja />}     />
          <Route path="/vinhas"    element={<Vinhas />}   />
          <Route path="/sobre"     element={<Sobre />}    />
          <Route path="/contacto"  element={<Contacto />} />
          <Route path="/carrinho"  element={<Carrinho />} />
          <Route path="/checkout"  element={<Checkout />} />
          <Route path="/checkout/sucesso"   element={<CheckoutResult variant="sucesso" />} />
          <Route path="/checkout/erro"      element={<CheckoutResult variant="erro" />} />
          <Route path="/checkout/cancelado" element={<CheckoutResult variant="cancelado" />} />
          <Route path="/douro-superior" element={<Territorio keyBase="territorio.douroSup" />} />
          <Route path="/vale-vilarica"  element={<Territorio keyBase="territorio.vilarica" />} />
          <Route path="/origem"         element={<Territorio keyBase="territorio.origem" bg={fotoOrigemHero} />} />
          <Route path="/privacidade"    element={<PoliticaPrivacidade />} />
          <Route path="/termos"         element={<TermosCondicoes />} />
          <Route path="/cookies"        element={<PoliticaCookies />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
